import { Col, Form, Input, Row, Select, Switch } from "antd";
import React from "react";
import { TextHeaderComponents } from "../../../TextHeaderComponents/TextHeaderComponents";
import TextArea from "antd/lib/input/TextArea";

type Props = { templateName: string };

const InformationTab = ({ templateName }: Props) => {
  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={12}>
          <Row>
            <Col>
              <TextHeaderComponents
                textHeaderProps={"Form Name :"}
              />
            </Col>
            <Col>
              <div className="flex justify-content-center">
                <p>{templateName}</p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col span={6}>
          <Form.Item label="Logic type" name="logictype" required>
            <Select
              showSearch
              options={[
                { label: "ActionService", value: "actionservice" },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col span={6}>
          <Form.Item label="Auto save" name="AutoSave" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row  gutter={[10, 10]}>
        <Col span={12}>
          <Form.Item label="Description" name="description">
            <TextArea rows={6} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default InformationTab;
